import styled, { css } from "styled-components";

export const ContentWrapper = styled.div`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    position: relative;
    color: white;
    padding: ${p => p.big ? '8px 16px' : '4px 16px'};

    &:hover {
        color: ${theme?.colour?.primary ?? "#0D5530"};
      }
    ${p => p.buttonType === 'text' && css`
      color: ${theme?.colour?.secondary ?? "#04333B"};
      &:hover {
        color: ${theme?.colour?.primary ?? "#1DBD6B"};
      }
    `}

    ${p => p.buttonType === 'outlined' && css`
      color: ${p.color ?? theme?.colour?.secondary ?? "#04333B"};
    `}
  `}

`;